var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilOutlineGreen = function SvgPencilOutlineGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    fillRule: "evenodd",
    d: "m8.225 17.16 10.68-10.681a.987.987 0 1 0-1.395-1.396L7.315 15.277h.001l-.486.486-.408.407-.648.645-.191 1.584 1.585-.186zm1.896.932 10.199-10.2a2.987 2.987 0 1 0-4.224-4.224l-10.68 10.68-1.545 1.54-.578 4.794 4.796-.563 1.143-1.14v.002l.406-.406z",
    clipRule: "evenodd"
  })));
};
export { SvgPencilOutlineGreen as Icon };
export default __webpack_public_path__ + "static/media/5c95f0b42771e62ab0325be640ba58d7.svg";